import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { IRequestParams, request } from 'helpers/request';
import { ENDPOINTS, logSagaErrorMessage } from 'utils';
import { ILocation, ILocationSearchParams } from '../models';
import * as types from '../ActionTypes';
import { getMatchedLocations } from '../map.actions';

function* getMatchedLocationsSaga({
	payload,
}: {
	type: string;
	payload: ILocationSearchParams;
}) {
	try {
		yield put(getMatchedLocations.loading());

		const getMatchedLocationsParams: IRequestParams = {
			url: ENDPOINTS.locationSearch,
			params: { ...payload },
		};

		const { data }: AxiosResponse<ILocation[]> = yield call(
			request,
			getMatchedLocationsParams,
		);

		yield put(getMatchedLocations.success(data));
	} catch (e) {
		logSagaErrorMessage('get matched locations', e);
		yield put(getMatchedLocations.fail(e));
	}
}

export function* mapSaga() {
	yield all([
		takeLatest(types.GET_MATCHED_LOCATIONS.DEFAULT, getMatchedLocationsSaga),
	]);
}
